import { combineReducers } from "@reduxjs/toolkit";
import enrollmentTools from "./enrollment-tools";

const enrollmentToolsReducer = combineReducers({
  enrollmentTools,
});

export default enrollmentToolsReducer;
